import { LockOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import { setOtpVerifiedEmailAction } from 'common/commonRedux/auth/actions';
import { useAxiosRequest, useIsDark } from 'common/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function SetNewPass() {
  const isDark = useIsDark();
  const resetPass = useAxiosRequest('');
  const navigate = useNavigate()
  const [form] = Form.useForm();
  const dispatch: any = useDispatch();
  const email = useSelector(
    (state: any) => state.auth?.profileData?.otpVerifiedEmail
  );


  const onFinish = async (values: any) => {
    const { newPassword } = values;   
    if (email) {
      resetPass.apiAction({
        urlObjKey: 'ResetPassword',
        method: 'PUT',
        params: {
          email:email,
          newPassword:newPassword,
        },
        isToast:true,
        // successMessage: 'Registration successful!',
        // errorMessage: 'An error occurred. Please try again',
        cb: () => {
          form.resetFields();
            dispatch(setOtpVerifiedEmailAction(''));
           navigate('/login')
        },
        onError: (error) => {
         console.log('New pass change:' ,error);
         
        },
      });
    }
  };

  const onFinishFailed = () => {};

  return (
    <Form
      form={form}
      layout="vertical"
      requiredMark={false}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      className=" w-full"
    >
      <Form.Item
        label={
          <span className={`text-md font-bold ${isDark ? 'text-white' : 'text-[#333]'}`}>
            New Password
            <span style={{ color: 'red', marginLeft: 3 }}>*</span>
          </span>
        }
        name="newPassword"
        className="mb-6 md:mb-2"
        rules={[
          {
            required: true,
            message: 'Please input a password',
            validateTrigger: 'onSubmit',
          },
          {
            min: 6,
            message: 'Password must be at least 6 characters',
            validateTrigger: 'onChange',
          },
          {
            pattern: /^(?=.*\d)/,
            message: 'Password must contain at least one number',
            validateTrigger: 'onChange',
          },
          {
            pattern: /^(?=.*[A-Z])/,
            message: 'Password must contain at least one uppercase letter',
            validateTrigger: 'onChange',
          },
          {
            pattern: /^(?=.*[a-z])/,
            message: 'Password must contain at least one lowercase letter',
            validateTrigger: 'onChange',
          },
          {
            pattern: /^(?=.*[@$#!%?&])/,
            message: 'Password must contain at least one special character',
            validateTrigger: 'onChange',
          },
        ]}
        validateFirst={true} // Ensures only one error message is displayed at a time
        hasFeedback
      >
        <Input.Password
        size='large'
          placeholder="Password"
          prefix={
            <LockOutlined className="site-form-item-icon mr-1 text-gray-500" />
          }
        />
      </Form.Item>
      <Form.Item
        label={
          <span className={`text-md font-bold ${isDark ? 'text-white' : 'text-[#333]'}`}>
            Confirm Password
            <span style={{ color: 'red', marginLeft: 3 }}>*</span>
          </span>
        }
        name="confirmPassword"
        className="mb-6 md:mb-2"
        dependencies={['newPassword']}
        rules={[
          { required: true, message: 'Please confirm password' },
          ({ getFieldValue }) => ({
            validator: (_, value) => {
              if (!value || getFieldValue('newPassword') === value) {
                return Promise.resolve();
              }
              return Promise.reject('Password does not match');
            },
          }),
        ]}
        hasFeedback
      >
        <Input.Password
          size='large'
          placeholder="Confirm Password"
          prefix={
            <LockOutlined className="site-form-item-icon mr-1 text-gray-500" />
          }
        />
      </Form.Item>
      {/* <Form.Item
        label={
          <span className={`text-md font-bold ${isDark ? 'text-white' : 'text-[#333]'}`}>
            New Password <span style={{ color: 'red' }}>*</span>
          </span>
        }
        name="new-password"
        className=""
        rules={[{ required: true, message: 'Please input your password!' }]}
      >
        <Input.Password
          placeholder="Password"
          prefix={<LockOutlined className="site-form-item-icon" />}
        />
      </Form.Item>
      <Form.Item
        label={
          <span className={`text-md font-bold ${isDark ? 'text-white' : 'text-[#333]'}`}>
            Confirm Password <span style={{ color: 'red' }}>*</span>
          </span>
        }
        name="confirm-password"
        className=""
        rules={[{ required: true, message: 'Please input your password!' }]}
      >
        <Input.Password
          placeholder="Password"
          prefix={<LockOutlined className="site-form-item-icon" />}
        />
      </Form.Item> */}
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
             size='large'
          className="w-full  !text-white  font-medium"
        >
          Save
        </Button>
      </Form.Item>
    </Form>
  );
}
